import { render, staticRenderFns } from "./related-orders-table.vue?vue&type=template&id=749a8c42&"
import script from "./related-orders-table.vue?vue&type=script&lang=ts&"
export * from "./related-orders-table.vue?vue&type=script&lang=ts&"
import style0 from "./related-orders-table.vue?vue&type=style&index=0&id=749a8c42&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports